/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const UpDoubleArrowSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M12 13.4693L7.92701 17.527C7.78851 17.6654 7.61701 17.7387 7.41251 17.747C7.20801 17.7554 7.02818 17.682 6.87301 17.527C6.72818 17.382 6.65576 17.2064 6.65576 17C6.65576 16.7937 6.72818 16.618 6.87301 16.473L11.3673 11.9788C11.4609 11.8853 11.5597 11.8193 11.6635 11.7808C11.7673 11.7423 11.8795 11.723 12 11.723C12.1205 11.723 12.2327 11.7423 12.3365 11.7808C12.4403 11.8193 12.5391 11.8853 12.6328 11.9788L17.127 16.473C17.2653 16.6115 17.3387 16.783 17.347 16.9875C17.3553 17.192 17.282 17.3719 17.127 17.527C16.982 17.6719 16.8063 17.7443 16.6 17.7443C16.3937 17.7443 16.218 17.6719 16.073 17.527L12 13.4693ZM12 7.46927L7.92701 11.527C7.78851 11.6654 7.61701 11.7387 7.41251 11.747C7.20801 11.7554 7.02818 11.682 6.87301 11.527C6.72818 11.382 6.65576 11.2064 6.65576 11C6.65576 10.7937 6.72818 10.618 6.87301 10.473L11.3673 5.97877C11.4609 5.88527 11.5597 5.81927 11.6635 5.78077C11.7673 5.74227 11.8795 5.72302 12 5.72302C12.1205 5.72302 12.2327 5.74227 12.3365 5.78077C12.4403 5.81927 12.5391 5.88527 12.6328 5.97877L17.127 10.473C17.2653 10.6115 17.3387 10.783 17.347 10.9875C17.3553 11.192 17.282 11.3719 17.127 11.527C16.982 11.6719 16.8063 11.7443 16.6 11.7443C16.3937 11.7443 16.218 11.6719 16.073 11.527L12 7.46927Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(UpDoubleArrowSvg)
export default ForwardRef
